import { Constant } from "app/shared/constant/constant";
import { ApiKey, ApiPathManager } from "app/shared/services/api-path";
import store from "app/shared/store/store";
import { instance } from "app/shared/util/token-store";
import { DataPaymentCardCreate, FetchPaymentCardAuthorizationRequest } from "../payment-card/reducer/types";

const createParam = (dataCreate: DataPaymentCardCreate) => {
  const cifNum = store.getState().account.USERPROFILE?.CIFNUMBER;
  const params = {
    cifNum: cifNum,
    accountNum: dataCreate.ACCOUNT_DEBIT?.ACCOUNTNO,
    cardId: dataCreate.TYPE === Constant.CARD.CARD_PAYMENT_TYPE.CRD ? dataCreate.CARD?.cardId : "",
    cardNum: dataCreate.TYPE === Constant.CARD.CARD_PAYMENT_TYPE.ACT ? dataCreate.CARD?.cardNum : "",
    amount: dataCreate.AMOUNT,
    description: dataCreate.DESCRIPTION,
  };
  return params;
};

const confirmParam = (dataCreate?: DataPaymentCardCreate) => {
  const cifNum = store.getState().account.USERPROFILE?.CIFNUMBER;
  const params = {
    cifNum: cifNum,
    accountNum: dataCreate?.ACCOUNT_DEBIT?.ACCOUNTNO,
    cardId: dataCreate?.TYPE === Constant.CARD.CARD_PAYMENT_TYPE.CRD ? dataCreate?.CARD?.cardId : "",
    cardNum: dataCreate?.TYPE === Constant.CARD.CARD_PAYMENT_TYPE.ACT ? dataCreate?.CARD?.cardNum : "",
    amount: dataCreate?.AMOUNT,
    description: dataCreate?.DESCRIPTION,
  };
  return params;
};

const authParam = (action?: FetchPaymentCardAuthorizationRequest) => {
  const params = {
    requestId: action?.payload?.requestId,
    otpTransId: action?.payload?.otpTransId,
    otpCode: action?.code,
  };
  return params;
};

// Khởi tạo
export const fetchPaymentCardCreateService = async (dataCreate: DataPaymentCardCreate) => {
  const { url } = ApiPathManager(ApiKey.PAYMENT_CARD_CREATE);
  const signature = store.getState().account.signature;
  const body = createParam(dataCreate);
  console.log("body: ", body);
  const response: any = await instance.post(url, body, { headers: { token: signature } });
  return response;
};

// Xác nhận
export const fetchPaymentCardConfirmService = async () => {
  const { url } = ApiPathManager(ApiKey.PAYMENT_CARD_CONFIRM);
  const signature = store.getState().account.signature;
  const dataCreate = store.getState().paymentCard.dataCreate;
  const body = confirmParam(dataCreate);
  console.log("body: ", body);
  const response: any = await instance.post(url, body, { headers: { token: signature } });
  return response;
};

// Xác thực
export const fetchPaymentCardAuthService = async (actionRq: FetchPaymentCardAuthorizationRequest) => {
  const { url } = ApiPathManager(ApiKey.PAYMENT_CARD_AUTH);
  const signature = store.getState().account.signature;
  const body = authParam(actionRq);
  console.log("body: ", body);
  const response: any = await instance.post(url, body, { headers: { token: signature } });
  return response;
};
